export const frenchTerritoriesCountryCodes = ['FR', 'GF', 'GP', 'MF', 'MQ', 'NC', 'PF', 'PM', 'RE', 'WF', 'YT']
